export default "# 昼休憩\n\n慣れない作業に集中して目と頭がさぞお疲れのことと思います。ゆっくり昼食を取って、午後に備えてリフレッシュしてください。\n\n";